import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import ProjectCreationLoginFormContainer from "./create_project_login_form_container";
import ProjectCreationSignupFormContainer from "./create_project_signup_form_container";

class BundleReplacedModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: []
    }

    this.handler = this.handler.bind(this)
  }



  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  handler(newState) {
    this.setState(newState)
  }


  render() {
    return (
      <div className="modal-background" onClick={() => this.props.changeParentState({ bundleReplacedModalOpen: false })}>
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="uploadPhotoModalHeadingGroup">
              <div className="settingsComponentHeading orderPreviewModalHeading"> Packages and Individual Servies have merged!</div>
              <div className="closeIconBundleReplaced" onClick={() => this.props.changeParentState({ bundleReplacedModalOpen: false })}><i className="fas fa-times"></i></div>
             </div>
            <div>You now have the flexibility to create whichever packages you want. The more services you add, the bigger the discount. Click on individual services to get started!</div>
            {/* <div className="accountRequiredButtons">
              <button className="submitOrderButton loginAccountButton" onClick={() => this.setState({ page: 2 })}>Log in</button>
              <button className="submitOrderButton" onClick={() => this.setState({ page: 3 })}>Close</button>
            </div> */}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(BundleReplacedModal);